module.exports = __webpack_public_path__ + "static/media/monika.f18dbc35.jpeg";